import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnsave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_5754_8464)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.89935 15.7C2.26338 15.8556 2.66585 15.8978 3.05425 15.8212C3.44265 15.7447 3.79896 15.5528 4.07668 15.2707L8.00001 11.3687L11.9233 15.2707C12.1063 15.4563 12.3242 15.6037 12.5645 15.7046C12.8048 15.8054 13.0627 15.8575 13.3233 15.858C13.5912 15.8572 13.8563 15.8035 14.1033 15.7C14.4704 15.5515 14.784 15.2957 15.0035 14.9662C15.2229 14.6366 15.3379 14.2486 15.3333 13.8527V3.33333C15.3323 2.4496 14.9808 1.60237 14.3559 0.97748C13.731 0.352588 12.8837 0.00105857 12 0L4.00001 0C3.11628 0.00105857 2.26905 0.352588 1.64416 0.97748C1.01927 1.60237 0.66774 2.4496 0.666681 3.33333V13.8527C0.662379 14.2489 0.777732 14.6372 0.997657 14.9667C1.21758 15.2963 1.53184 15.5519 1.89935 15.7Z",
			fill: "#333333"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5754_8464",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgUnsave;
